export default __webpack_public_path__ + "static/media/tech-mahindra.f593439c.svg";